<template>
  <div class="zycr clearfix">
    <div class="li animation srcospcur">
      <div class="box clearfix">
        <div class="img">
          <img :src="list[0].imageUrl" width="100%" />
        </div>
        <div class="txt whbfb">
          <div class="table">
            <div class="table-cell">
              <h3 class="ft24">
                <b>{{list[0].title}}</b>
              </h3>
              <p>为员工提供培养资源和平台，建立各类后备人才培养计划，致力于培养一代工商精英。</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="li animation" v-for="item in list.slice(1)" :key="item.id">
      <div class="tit ft24">{{item.title}}</div>
      <div class="box1 clearfix">
        <div class="img im1">
          <img width="100%" :src="item.imageUrl" />
        </div>
        <div class="txtBox" v-html="item.content"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: [Object, Array]
  },
  data() {
    return {
      list: this.$props.data || []
    };
  }
};
</script>